(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfClickover', function() {
    return {
      restrict: 'A',
      link: function(scope, ele, attrs) {
        var defaults, options, props;
        defaults = {
          html: true,
          container: '#bs2-container',
          trigger: 'outsideClick'
        };
        props = scope.$eval(attrs.mfClickover);
        options = $.extend({}, defaults, props);
        return ele.clickover(options);
      }
    };
  });

}).call(this);
